import { DTOExportJobResponse, DTOPipelineListQuery, DTOPipelineListResponse, DTOPipelineResponse } from "../../dto";
import { DTOPipelineCreateBody, DTOPipelineTriggerBody, DTOPipelineUpdateBody } from "../../payloads";
import { RequestExecutor } from "../../transport";

export class PipelinesEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(workspaceId: string, query: DTOPipelineListQuery) {
    const queryWithStrings = Object.fromEntries(
      Object.entries(query)
        .filter(e => !!e[1])
        .map(([k, v]) => [k, v.toString()])
    );

    return this.requestExecutor.json(`/codegen/workspaces/${workspaceId}/pipelines`, DTOPipelineListResponse, {
      query: new URLSearchParams(queryWithStrings),
    });
  }

  create(workspaceId: string, payload: DTOPipelineCreateBody) {
    return this.requestExecutor.json(`/codegen/workspaces/${workspaceId}/pipelines`, DTOPipelineResponse, {
      body: payload,
      method: "POST",
    });
  }

  update(designSystemId: string, pipelineId: string, payload: DTOPipelineUpdateBody) {
    return this.requestExecutor.json(`/design-systems/${designSystemId}/pipelines/${pipelineId}`, DTOPipelineResponse, {
      body: payload,
      method: "PUT",
    });
  }

  trigger(workspaceId: string, pipelineId: string, payload: DTOPipelineTriggerBody) {
    return this.requestExecutor.json(
      `/codegen/workspaces/${workspaceId}/pipelines/${pipelineId}/trigger`,
      DTOExportJobResponse,
      {
        body: payload,
        method: "POST",
      }
    );
  }
}
